import { definitionFactory } from '../definitionFactory';
import { rangeAreaStr } from '../../../utils/text';
import { onDeleteAction } from '../definitionsDeleteAction';

export const totalAreaInputDefinition = definitionFactory({
  key: 'total_area',
  mapper: ({ gte, lte }) => gte || lte ? [{
    label: rangeAreaStr('Общая площадь', gte, lte),
    value: { gte, lte },
  }] : [],
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'total_area', options);
  },
});
